module.exports = __webpack_public_path__ + "img/toolbar-left.4622455c.png";